<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-b-modal.addPermission v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('permission.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border >
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditPermission()" v-if="permissionList.includes(permission.edit)">{{$t('permission.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deletePermission()" v-if="permissionList.includes(permission.delete)">{{$t('permission.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addPermission" :title="$t('permission.table_add')" @ok="addPermission" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addPermissionForm" @submit.prevent="addPermission">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_category')}}</template>
                            <b-form-radio name="category" value="menu" v-model="ajaxAdd.category">{{$t('permission.table_menu')}}</b-form-radio>
                            <b-form-radio name="category" value="button" v-model="ajaxAdd.category">{{$t('permission.table_button')}}</b-form-radio>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_file')}}</template>
                            <b-form-input name="file" v-model="ajaxAdd.file"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_path')}}</template>
                            <b-form-input name="path" v-model="ajaxAdd.path"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_route')}}</template>
                            <b-form-input name="route"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch v-model="ajaxAdd.status"></b-form-checkbox>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editPermission" :title="$t('permission.table_edit')" @ok="editPermission" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editPermissionForm" @submit.prevent="editPermission">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_category')}}</template>
                            <b-form-radio name="category" value="menu" v-model="ajaxEdit.category">{{$t('permission.table_menu')}}</b-form-radio>
                            <b-form-radio name="category" value="button" v-model="ajaxEdit.category">{{$t('permission.table_button')}}</b-form-radio>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_file')}}</template>
                            <b-form-input name="file" v-model="ajaxEdit.file"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_path')}}</template>
                            <b-form-input name="path" v-model="ajaxEdit.path"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_route')}}</template>
                            <b-form-input name="route" v-model="ajaxEdit.route"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('permission.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {permissionAjaxTable,permissionSearch,permissionAddCsrf,permissionAdd,getPermissionEdit,permissionEdit,permissionDelete} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',category:'',code:'',file:'',path:'',status:''},
            ajaxAdd:{category:'',file:'',path:'',status:'0'},
            ajaxEdit:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'9D4AAA',
                edit:'541615',
                delete:'A3500E'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('permission.table_id'),
                width: '130'
            },{
                prop: "category",
                label: this.$t('permission.table_category'),
                width: '253'
            },{
                prop: "code",
                label: this.$t('permission.table_code'),
                width: '253'
            },{
                prop: "file",
                label: this.$t('permission.table_file'),
                width: '380'
            },{
                prop: "path",
                label: this.$t('permission.table_path'),
                width: '380'
            },{
                prop: "route",
                label: this.$t('permission.table_route'),
                width: '380'
            },{
                prop: "status",
                label: this.$t('permission.table_status'),
                width: '126'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = permissionAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.category,this.ajaxSearch.code,this.ajaxSearch.file,this.ajaxSearch.path,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addPermission(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxAdd.category){
                    this.validate = false;
                    this.errors.push('setting_permission.error_category_empty');
                }
                if(!this.ajaxAdd.file){
                    this.validate = false;
                    this.errors.push('setting_permission.error_file_empty');
                }
                if(!this.ajaxAdd.path){
                    this.validate = false;
                    this.errors.push('setting_permission.error_path_empty');
                }
                if(this.validate){
                    var form = document.getElementById('addPermissionForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    var result = permissionAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();                   
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();                   
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }         
            }
        },getEditPermission(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getPermissionEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    if(value.valid){
                        self.preloader(false)
                        self.$bvModal.show('editPermission');
                        self.ajaxEdit = value.data;
                    }else{
                        self.preloader(true)
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editPermission(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.category){
                    this.validate = false;
                    this.errors.push('setting_permission.error_category_empty');
                }
                if(!this.ajaxEdit.file){
                    this.validate = false;
                    this.errors.push('setting_permission.error_file_empty');
                }
                if(!this.ajaxEdit.path){
                    this.validate = false;
                    this.errors.push('setting_permission.error_path_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editPermissionForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = permissionEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();                   
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();                   
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }   
        },deletePermission(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = permissionDelete(formData);		
                        result.then(function(value){
                            if(value.valid){
                                self.preloader(false);
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();                   
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();                   
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
